import React from 'react';
import styled from 'styled-components';
import Select, { components } from 'react-select';
import { isMobileOnly } from 'react-device-detect';
import { findIndex } from 'lodash';
import { useState, useEffect,useRef } from 'react';
import { findDOMNode } from 'react-dom';
import $ from 'jquery';
/**
 * DrowDown Select Button
 */
const MyEsOrderBtnBlock = styled.div`
    height: ${props => props.height || '40px'};
    margin-top: ${props => props.marginTop || '0px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-left: ${props => props.marginLeft || '0px'};
    margin-right: ${props => props.marginRight || '0px'};
    position: relative;

    .arrow {
        ${isMobileOnly?`
        margin-top: 5px;
        `:`
        margin-top: 7px;
        `};
        font-family: sans-serif;
        letter-spacing: -2px;
        //padding-right: 3px;
        float: left;
        //padding-top: 3px;
        height: 11px;
        width: 12px;
        margin-right: 3px;
        background: url(/assets/images/icon/es_order_arrow.svg) center center/auto no-repeat;
    }
`;


const MyEsOrderBtnMobileSelect = styled.select`
    width: ${props => props.width || 'fit-content'};
    border: none;
    padding: 0;
    //width: 100%;
    font-size: 12px;
    //padding: 10px;
    padding: 0px;
    //padding-right: 4vw;
    background-color: #ffffff;
    //height: 100%;
    //border: 1px solid #c1c1c1;
    border-radius: 4px;
    color: ${props => props.color || '#333333'};

    appearance:none; /* 기본 스타일 없애기 */
    -webkit-appearance:none;
    -moz-appearance:none;
    -o-appearance:none;

    .select::-ms-expand {display:none;}
    
    &:focus {
        outline: 0;
        //border: 1px solid #ffc742;
        border-radius: 4px;
      }

      &:active {
        outline: 0;
        //border: 1px solid #ffc742;
        border-radius: 4px;
      }

      ::before {
        ontent: "&uaddr;&daddr;";
      }
`;

const SelectArrowImgBtn = styled.div`
    position: absolute;
    right: 4px;
    top: 12px;
`;

const MyEsOrderBtnMobileOption = styled.option`

`;

const SelectOrderBoxSecondWrapSelectListUlBlock = styled.ul`
    margin-right: 0;
    padding: 6px 0;
    //margin-right: 30px;
    color: #666;
    font-size: 14px;
    position: relative;
`;
const SelectOrderBoxSecondWrapSelectListSelectedLiBlock = styled.li`
    color: #333333;
    font-size: 14px;
    //font-weight: 400;
    cursor: pointer;
    //height = '20px';
    text-align: right;
    width: ${props => props.width || 'fit-content'};

   /*  ::after {
    content: '';
    display: inline-block;
    width: 13px;
    height: 7px;
    margin-left: 10px;
    background: url(/assets/images/icon/ds-icon.png) center center/cover no-repeat;
    } */
`;

const SelectOrderBoxSecondWrapSelectListLiBlock = styled.li`
    cursor: pointer;
    display : ${props => props.display};
`;

const SelectOrderBoxSecondWrapSelectListSubUlBlock = styled.ul`
    width: 100px;
    right: 0;
    text-align: left;
    top: 35px;
    right: 0;
    width: max-content;
    width: auto;
    padding: 20px;
    background-color: #fff;
    border: 1px solid #fcc643;
    border-radius: 4px;
    //display: none;
    position: absolute;
    //width: 100%;
    z-index: 1;
    display : ${props => props.display};
`;

const SelectOrderBoxSecondWrapSelectListSubLiBlock = styled.li`
    margin-bottom: 10px;
    word-break: keep-all;
    cursor: pointer;
    font-weight: ${props => props.weight};
`;

const SLIDE_DURATION = 150;


const MyEsOrderBox = ({ options, placeholder,
    marginTop, marginBottom, marginLeft, marginRight,
    height, onChange, isDisabled = false, reset = false, valueDefault }) => {

    const [displaySelectBox, setDisplaySelectBox] = useState(false);
    const selectRef = useRef(null);
    const selectContainRef = useRef(null);

    const [options2, setOptoins2] = useState([]);
    const [gray, setGray] = useState(true);
    const [width, setWidth] = useState(isMobileOnly?'33px':'54px');

    useEffect(() => {
        setOptoins2(options);
        
        if(options2 && options2.length>0){
            let length = options2[0].label.length;
            let width = (length*11) + 'px';
            if(!isMobileOnly) {
                width = (length*13) + 15 + 'px';
            }
            setWidth(width);
        }
        
    }, [options]);

    useEffect(() => {

        if(valueDefault) {
            let length = valueDefault.label.length;
            //console.log("valueDefault = " + valueDefault.label)
            
            let width = (length*11) + 'px';
            if(!isMobileOnly) {
                width = (length*13) + 15 + 'px';
            }
            setWidth(width);
        }
        
    }, [valueDefault]);

    const onChanegValue = (e) => {
        if(e.target.value*1 === -1) {
            let param = {value: -1};
            onChange(param);
            setGray(true);
        } else {
            let idx = findIndex(options2, (curitem) => {
                return (curitem.value*1 === e.target.value*1);
            })

            if(idx >= 0) {
                //onChange(options2[idx]);
                setGray(false);
                let length = options2[idx].label.length;
                let width = (length*11) + 'px';
                setWidth(width);
                onChange(options2[idx],width);
            }
        }

    }

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (selectContainRef.current && !selectContainRef.current.contains(event.target)) {

                if (selectRef.current && !selectRef.current.contains(event.target)) {
                    //setDisplaySelectBox(false);
                    const el = findDOMNode(selectRef.current);
                    //$(el).slideUp(SLIDE_DURATION);
                    $(el).slideUp(SLIDE_DURATION, function () {
                        setDisplaySelectBox(false);
                    });
                }
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [selectContainRef, selectRef]);

    const handleSelectClick = () => {
        //console.log("handleSelectClick displaySelectBox="+displaySelectBox);
        if (displaySelectBox) {

            // console.log("slideUp")
            if (selectRef.current) {
                const el = findDOMNode(selectRef.current);

                $(el).slideUp(SLIDE_DURATION, function () {
                    setDisplaySelectBox(false);
                });
            }
        }
        else {
            setDisplaySelectBox(true);
            if (selectRef.current) {
                const el = findDOMNode(selectRef.current);
                // console.log("slideDown")
                $(el).slideDown(SLIDE_DURATION);
                //$(el).parents('li').addClass('active');
            }
        }
    }

    const getSelectedName = () => {
        //console.log("value = " + JSON.stringify(valueDefault))
        if (valueDefault) {
            return valueDefault.label;
        }
        else {
            valueDefault = options[0];
            return options[0].label;
        }
    }

    const handleChangeValue = (option) => {
        if (option.value === valueDefault.value) {

        }
        else {
            if (onChange) {
                let idx = findIndex(options2, (curitem) => {
                    return (curitem.value*1 === option.value*1);
                })
    
                if(idx >= 0) {
                    //onChange(options2[idx]);
                    setGray(false);
                    let length = options2[idx].label.length;
                    let width = (length*13) + 15 + 'px';
                    setWidth(width);
                    onChange(options2[idx],width);
                }

                onChange(option);
            }
        }

        if (selectRef.current) {
            const el = findDOMNode(selectRef.current);
            $(el).slideUp(SLIDE_DURATION, function () {
                setDisplaySelectBox(false);
            });
        }
    }

    return (isMobileOnly?
        <MyEsOrderBtnBlock
            height={height}
            marginTop={marginTop}
            marginBottom={marginBottom}
            marginLeft={marginLeft}
            marginRight={marginRight}>
                <div className="arrow"></div>
                <MyEsOrderBtnMobileSelect  name="select" id="select" color={gray? '#333333':'#333333'} width={width} onChange={onChanegValue}>
                    {
                        
                        options.map((option, index) => {
                            return (valueDefault&&valueDefault.value === option.value?
                                <MyEsOrderBtnMobileOption key={option.value} value={option.value} disabled={option.disabled === 'yes'} selected>
                                    {option.label}
                                    </MyEsOrderBtnMobileOption>
                                :
                                <MyEsOrderBtnMobileOption key={option.value} value={option.value} disabled={option.disabled === 'yes'}>
                                    {option.label}
                                    </MyEsOrderBtnMobileOption>
                                    );
                        })
                    }
              </MyEsOrderBtnMobileSelect>
              {/* <SelectArrowImgBtn><SelectArrowImg /></SelectArrowImgBtn> */}
        </MyEsOrderBtnBlock>
        :
        <MyEsOrderBtnBlock className="clearfix"
            height={height}
            marginTop={marginTop}
            marginBottom={marginBottom}
            marginLeft={marginLeft}
            marginRight={marginRight}>
                <div className="arrow"></div>
            <SelectOrderBoxSecondWrapSelectListUlBlock>
                <SelectOrderBoxSecondWrapSelectListSelectedLiBlock ref={selectContainRef} width={width} onClick={handleSelectClick}>
                    {getSelectedName()}
                </SelectOrderBoxSecondWrapSelectListSelectedLiBlock>
                <SelectOrderBoxSecondWrapSelectListLiBlock display={displaySelectBox ? "block" : "none"}>
                    <SelectOrderBoxSecondWrapSelectListSubUlBlock ref={selectRef} className="sz-select_sub2" display={displaySelectBox ? "block" : "none"}>
                        {
                            options.map((option) => (
                                <SelectOrderBoxSecondWrapSelectListSubLiBlock key={option.value}
                                    onClick={() => { handleChangeValue(option) }}
                                    weight={option.value === valueDefault.value ? 700 : 400}>
                                    {option.label}
                                </SelectOrderBoxSecondWrapSelectListSubLiBlock>
                            ))
                        }
                    </SelectOrderBoxSecondWrapSelectListSubUlBlock>
                </SelectOrderBoxSecondWrapSelectListLiBlock>
            </SelectOrderBoxSecondWrapSelectListUlBlock>
        </MyEsOrderBtnBlock>
    );
};

export default MyEsOrderBox;